export default __webpack_public_path__ + "static/youtube-946ecfdc2e20844787438b53a7265233.svg";